import { Order } from '@commercetools/frontend-domain-types/cart/Order';

/**
 * Get order by cartId - Utility function
 * This method queries CommerceTools directly with cartId filter and limit=1
 * 
 * @param cartId - The cart ID to search for
 * @returns Promise<Order | null> - The matching order or null if not found
 */
export const getOrderByCartId = async (cartId: string): Promise<Order | null> => {
  try {
    // Dynamic import to avoid build issues across different projects
    const { sdk } = await import('sdk');
    
    const response = await sdk.callAction({
      actionName: 'cart/getOrderByCartId',
      payload: { cartId },
    });
    
    return response.isError ? null : (response.data as Order);
  } catch (error) {
    console.error('Error fetching order by cartId:', error);
    return null;
  }
};

// Legacy hook interface for backward compatibility
// This is now just a wrapper around the utility function
export interface UseCartSharedReturn {
  getOrderByCartId: (cartId: string) => Promise<Order | null>;
}

/**
 * @deprecated Use the direct utility function `getOrderByCartId` instead
 * This hook wrapper is kept for backward compatibility but may cause issues
 * in monorepo setups with multiple React instances
 */
export const useCartShared = (): UseCartSharedReturn => {
  return {
    getOrderByCartId,
  };
};